// Visit tracking
export const COOKIE_VISITOR_ID = 'oc-visitor-id-3'
export const BROKEN_COOKIE_VISITOR_ID = 'oc-visitor-id-2'

// Tica
export const COOKIE_TICA_REFERRAL = 'tica_referral'
export const COOKIE_TICA_REFERRAL_LOGO = 'tica_referral_logo'
export const TICA_CONNECT_MODAL_COOKIE_NAME = 'oc-tcm-match'

// export const OC_ODF_COOKIE_NAME = 'oc-odf-modal'
// More specific cookie name to avoid conflicts with other cookies just for the popup event since it within the normal expiration time
// Can removed for the next ODF and changes back to the old "oc-odf-modal" name
export const OC_ODF_COOKIE_NAME = 'oc-odf-modal-popup-2026'

export const OC_SHOW_WELCOME_MODALS_COOKIE_NAME = 'oc-show-welcome-modals'

export const COOKIE_MODE = 'oc-mode'

export const COOKIE_MARKETPLACE_VIEW = 'oc-marketplace-view'

export const COOKIE_EXPIRATION_DAYS = {
    ONE_YEAR: 365,
    TWO_DAYS: 2,
}
